/* BeeBike — zajednicka skripta za celu temu.
   1. Prekidac svetli/tamni rezim (data-theme na <html>, pamti se u localStorage)
   2. Otkrivanje sekcija pri skrolu ([data-reveal])
   3. Brojaci koji "broje" do vrednosti ([data-countup])
   4. Mesecna rata iz cene ([data-bb-monthly][data-price]) po istoj formuli kao stranica za rate
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Rezim ── */
  function setTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem('bb-theme', t); } catch (e) {}
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', t === 'dark' ? 'true' : 'false');
    });
  }
  function bindTheme(root) {
    (root || document).querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      if (b.__bb) return;
      b.__bb = true;
      b.setAttribute('aria-pressed', document.documentElement.getAttribute('data-theme') === 'dark' ? 'true' : 'false');
      b.addEventListener('click', function () {
        setTheme(document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
      });
    });
  }

  /* ── 2. Reveal ── */
  var io = null;
  function revealNow(el) { el.classList.add('is-in'); }
  function bindReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach(revealNow); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { revealNow(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) {
      // Sto je element vec u ekranu pri ucitavanju, pokazi ga odmah da hero ne "trepce"
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) revealNow(el); else io.observe(el);
    });
  }

  /* ── 3. Brojaci ── */
  function fmt(n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function tween(el, from, to, dur, suffix, prefix) {
    prefix = prefix || ''; suffix = suffix || '';
    if (reduceMotion || dur <= 0) { el.textContent = prefix + fmt(to) + suffix; return; }
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(from + (to - from) * e) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function bindCountup(root) {
    (root || document).querySelectorAll('[data-countup]').forEach(function (el) {
      if (el.__bb) return;
      el.__bb = true;
      var to = parseFloat(el.getAttribute('data-countup')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      var run = function () { tween(el, 0, to, 1200, suffix, prefix); };
      if (reduceMotion || !('IntersectionObserver' in window)) { run(); return; }
      var o = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { run(); o.disconnect(); }
      }, { threshold: 0.4 });
      o.observe(el);
    });
  }

  /* ── 4. Rate ── */
  var RATE = parseFloat(window.BB_RATE || '0.9125') / 100;
  var MONTHS = parseInt(window.BB_MONTHS || '24', 10);
  function pmtFactor(r, n) {
    if (r === 0) return 1 / n;
    var f = Math.pow(1 + r, n);
    return r * f / (f - 1);
  }
  function monthly(price, months) { return price * pmtFactor(RATE, months || MONTHS); }
  function bindMonthly(root) {
    (root || document).querySelectorAll('[data-bb-monthly]').forEach(function (el) {
      var price = parseFloat(el.getAttribute('data-price') || '0');
      if (price <= 0) return;
      var months = parseInt(el.getAttribute('data-months') || MONTHS, 10);
      el.textContent = fmt(monthly(price, months));
    });
  }

  window.bb = { fmt: fmt, tween: tween, monthly: monthly, months: MONTHS, setTheme: setTheme };

  function init(root) { bindTheme(root); bindReveal(root); bindCountup(root); bindMonthly(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Shopify editor ponovo iscrtava sekcije, pa se vezivanja ponavljaju
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
